import { createFileRoute } from "@tanstack/react-router";
import headImg from "@/assets/public/story-autonomy.jpg";
import { PageHead, Shell, NewsletterForm } from "@/components/public/site";
import scout from "@/assets/public/scout-binos.png";

export const Route = createFileRoute("/newsletter/")({
  head: () => ({
    meta: [
      { title: "Newsletter — Maven Scouts" },
      { name: "description", content: "Subscribe to The Scout Report: dual-use technology, defense, energy, and Gulf South innovation news from Maven Scouts." },
      { property: "og:title", content: "Newsletter — Maven Scouts" },
      { property: "og:description", content: "Subscribe to The Scout Report from Maven Scouts." },
    ],
  }),
  component: Page,
});

const issues = [
  { no: "Issue 03", title: "Securing Gulf Coast energy with dual-use tech", body: "How autonomy and sensing are reshaping protection of refineries, pipelines, and LNG terminals." },
  { no: "Issue 02", title: "From sugarcane to sensors", body: "Agriculture technology with defense applications — and the founders building it." },
  { no: "Issue 01", title: "Navigating SBIR/STTR in 2026", body: "What's changed, what works, and how to position for DoD transition." },
];

function Page() {
  return (
    <Shell>
      <PageHead image={headImg} alt="Autonomous vessel on a Louisiana bayou" code="Newsletter" title="The Scout Report" sub="Monthly intelligence on dual-use technology across defense, energy, maritime, aerospace, and agriculture." />
      <div className="mx-auto max-w-7xl px-6 py-20">
        <div className="grid items-center gap-8 overflow-hidden rounded-lg border border-border bg-card p-10 shadow-sm md:grid-cols-[1fr_440px]">
          <div>
            <h2 className="font-display text-3xl uppercase">Subscribe</h2>
            <p className="mt-2 text-muted-foreground">Get the next issue in your inbox.</p>
            <div className="mt-6 max-w-xl"><NewsletterForm /></div>
          </div>
          <img src={scout} alt="" aria-label="Scout looking forward through binoculars, drawn as an animated 3D wireframe" className="mx-auto w-80 mix-blend-multiply md:w-[440px]" />
        </div>
        <h2 className="mt-16 font-mono text-xs uppercase tracking-[0.3em] text-primary">Recent issues</h2>
        <div className="mt-6 grid gap-6 md:grid-cols-3">
          {issues.map((i) => (
            <div key={i.no} className="rounded-lg border border-border bg-card p-8">
              <p className="font-mono text-xs text-primary">{i.no}</p>
              <h3 className="mt-3 font-display text-xl uppercase">{i.title}</h3>
              <p className="mt-3 text-sm text-muted-foreground">{i.body}</p>
            </div>
          ))}
        </div>
      </div>
    </Shell>
  );
}
